module.exports = __webpack_public_path__ + "img/dashboard-corner-image.df86f544.png";